<script setup lang="ts">
import RcPartStatusBadge from '@/components/rc/common/RcPartStatusBadge.vue'
import type { IDetailsPart } from '@/types/rc/miners'
import {
  PartStatusIcons,
  PartStatusTagTypes,
  NO_PART_STATUS_ICON,
  NO_PART_STATUS_TAG_TYPE,
} from '@/types/rc/miners/PartStatus'
import { Icon } from '@iconify/vue'

defineProps<{
  part: IDetailsPart
}>()
</script>

<template>
  <el-tooltip effect="light" placement="left">
    <el-tag class="w-6 h-6" :type="part.status ? PartStatusTagTypes[part.status] : NO_PART_STATUS_TAG_TYPE">
      <icon :icon="part.status ? PartStatusIcons[part.status] : NO_PART_STATUS_ICON" :height="20" />
    </el-tag>

    <template #content>
      <div class="flex flex-col w-48 text-base p-2 gap-4 text-xs">
        <div>
          <div class="text-tertiary mb-1">Initial status</div>
          <rc-part-status-badge :status="part.initial_diagnostic" />
        </div>
        <div>
          <div class="text-tertiary mb-1">Part status</div>
          <rc-part-status-badge :status="part.status" />
        </div>
        <!-- Either failure type or failure reason (failure.comment) when failure type is 'Other' -->
        <div v-if="part.failure">
          <template v-if="part.failure.failure_type.description !== 'Other'">
            <div class="text-tertiary">Failure type</div>
            <p>{{ part.failure.failure_type.description }}</p>
          </template>
          <template v-else>
            <div class="text-tertiary">Failure reason</div>
            <p>{{ part.failure.comment }}</p>
          </template>
        </div>
      </div>
    </template>
    <icon icon="ph:info-circle-fill" />
  </el-tooltip>
</template>
